module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-04.22e85cd0.png";